var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-us-image-container"},[_c('b-img',{staticClass:"about-us-image",attrs:{"src":_vm.src,"alt":_vm.alt}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }